import AssetUpload from 'components/AssetUpload';
import { Form, FormProps } from 'antd';
import type { ICourseShow } from 'interfaces/courses';

interface TabAssetsProps {
  formProps: FormProps;
  onFinish: (values: ICourseShow) => void;
  course?: ICourseShow;
}

export const TabAssets = ({ formProps, onFinish, course }: TabAssetsProps) => {
  return (
    <Form {...formProps} onFinish={onFinish} layout="vertical">
      <Form.Item
        label="Cabeçalho"
        name={['media', 'header_image']}
        rules={[
          {
            required: false
          }
        ]}
      >
        <AssetUpload
          accept="image/png, image/jpeg"
          type="course"
          src={course?.media?.header_image}
        />
      </Form.Item>
      <Form.Item
        label="Card"
        name={['media', 'card_image']}
        rules={[
          {
            required: false
          }
        ]}
      >
        <AssetUpload
          accept="image/png, image/jpeg"
          type="course"
          src={course?.media?.card_image}
        />
      </Form.Item>
    </Form>
  );
};
